// extracted by mini-css-extract-plugin
export default {"advert":"OOJELX7"};